import { UiNavBannerModel } from "../../models";

export function mockUiNavBannerModel({
    id = "ui-nav-banner-1234",
    type = "uiNavBanner",
    locale = "en",
    content = mockUiNavBannerModelContent()
}: Partial<UiNavBannerModel> = {}): UiNavBannerModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiNavBannerModelContent = UiNavBannerModel["content"];

export function mockUiNavBannerModelContent({
    entryTitle = "Trello Banner",
    titleHeading = "Lorem Ipsum",
    description = "Lorem ipsum sit dolor amet adepiscing consecutor qui",
    ...optionals
}: Partial<UiNavBannerModelContent> = {}): UiNavBannerModelContent {
    return {
        entryTitle,
        titleHeading,
        description,
        ...optionals
    };
}
